"use client"

import Link from "next/link"
import { Navbar } from "@/components/layout/navbar"
import { ArrowLeft, Mail, MapPin, Phone } from "lucide-react"
import { motion } from "framer-motion"

const SvgFacebook = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
        <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
    </svg>
)

const SvgDiscord = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
        <path d="M20.317 4.492c-1.53-.69-3.17-1.2-4.885-1.49a.075.075 0 0 0-.079.036c-.21.369-.444.85-.608 1.23a18.566 18.566 0 0 0-5.487 0 12.36 12.36 0 0 0-.617-1.23A.077.077 0 0 0 8.562 3c-1.714.29-3.354.8-4.885 1.491a.07.07 0 0 0-.032.027C.533 9.093-.32 13.555.099 17.961a.08.08 0 0 0 .031.055 20.03 20.03 0 0 0 5.993 2.98.078.078 0 0 0 .084-.026c.462-.62.874-1.275 1.226-1.963.021-.04.001-.088-.041-.104a13.201 13.201 0 0 1-1.872-.878.075.075 0 0 1-.008-.125c.126-.093.252-.19.372-.287a.075.075 0 0 1 .078-.01c3.927 1.764 8.18 1.764 12.061 0a.075.075 0 0 1 .079.009c.12.098.245.195.372.288a.075.075 0 0 1-.006.125c-.598.344-1.22.635-1.873.877a.074.074 0 0 0-.041.105c.36.687.772 1.341 1.225 1.962a.077.077 0 0 0 .084.028 19.963 19.963 0 0 0 6.002-2.981.076.076 0 0 0 .032-.054c.5-5.094-.838-9.52-3.549-13.442a.06.06 0 0 0-.031-.028zM8.02 15.278c-1.182 0-2.157-1.069-2.157-2.38 0-1.312.956-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.956 2.38-2.157 2.38zm7.975 0c-1.183 0-2.157-1.069-2.157-2.38 0-1.312.955-2.38 2.157-2.38 1.21 0 2.176 1.077 2.157 2.38 0 1.312-.946 2.38-2.157 2.38z" />
    </svg>
)

const SvgWhatsApp = () => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z" />
        <path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.558 4.116 1.532 5.845L.057 23.492a.5.5 0 0 0 .609.61l5.748-1.505A11.95 11.95 0 0 0 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.9 0-3.681-.51-5.21-1.402l-.374-.22-3.882 1.016 1.025-3.782-.238-.39A9.944 9.944 0 0 1 2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
    </svg>
)

const contactItems = [
    {
        icon: <MapPin className="h-6 w-6" />,
        colorClass: "bg-primary/10 text-primary",
        label: "Our Office",
        value: "Apartment 402, 3rd Floor, House 108,\nRoad 10/2, Block D, Niketan,\nGulshan 1, Dhaka, Bangladesh",
        href: "https://maps.google.com/?q=Gulshan+1+Dhaka+Bangladesh",
        isMultiLine: true,
    },
    {
        icon: <Phone className="h-6 w-6" />,
        colorClass: "bg-emerald-500/10 text-emerald-500",
        label: "Phone",
        value: "+880 1766-966772",
        href: "tel:+8801766966772",
    },
    {
        icon: <Mail className="h-6 w-6" />,
        colorClass: "bg-indigo-500/10 text-indigo-500",
        label: "Email",
        value: "info@dsatschool.com",
        href: "mailto:info@dsatschool.com",
    },
]

const socials = [
    {
        label: "Facebook",
        href: "https://www.facebook.com/dsatschool",
        icon: <SvgFacebook />,
        colorClass: "bg-blue-600/10 text-blue-600 hover:bg-blue-600 hover:text-white",
    },
    {
        label: "Discord",
        href: "https://discord.gg/66j2f4wnA4",
        icon: <SvgDiscord />,
        colorClass: "bg-indigo-500/10 text-indigo-500 hover:bg-indigo-500 hover:text-white",
    },
    {
        label: "WhatsApp",
        href: "https://api.whatsapp.com/send/?phone=8801766966772&text&type=phone_number&app_absent=0",
        icon: <SvgWhatsApp />,
        colorClass: "bg-emerald-500/10 text-emerald-500 hover:bg-emerald-500 hover:text-white",
    },
]

export default function ContactPage() {
    return (
        <div className="flex min-h-screen flex-col bg-background">
            <Navbar />
            <main className="flex-1">
                <section className="py-20 relative overflow-hidden">
                    {/* Background Decorations */}
                    <div className="absolute top-0 right-0 -z-10 w-[500px] h-[500px] bg-primary/5 rounded-full blur-3xl" />
                    <div className="absolute bottom-0 left-0 -z-10 w-[500px] h-[500px] bg-indigo-500/5 rounded-full blur-3xl" />

                    <div className="container mx-auto px-6 md:px-8 max-w-3xl">
                        <Link
                            href="/"
                            className="inline-flex items-center text-sm text-muted-foreground hover:text-primary mb-10 transition-colors"
                        >
                            <ArrowLeft className="mr-2 h-4 w-4" /> Back to Home
                        </Link>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                            className="space-y-12"
                        >
                            <div className="space-y-3">
                                <h1 className="text-4xl md:text-5xl font-bold tracking-tight">Contact Us</h1>
                                <p className="text-muted-foreground text-lg leading-relaxed">
                                    Have questions? We&apos;re just a message away. Reach out through any of the channels below.
                                </p>
                            </div>

                            {/* Contact Details */}
                            <div className="space-y-8">
                                {contactItems.map((item, i) => (
                                    <motion.a
                                        key={item.label}
                                        href={item.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        initial={{ opacity: 0, x: -20 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ delay: 0.1 + i * 0.1 }}
                                        className="flex items-start gap-5 group hover:no-underline"
                                    >
                                        <div
                                            className={`p-3.5 rounded-2xl shrink-0 transition-transform group-hover:scale-110 ${item.colorClass}`}
                                        >
                                            {item.icon}
                                        </div>
                                        <div className="pt-1">
                                            <p className="text-xs font-semibold uppercase tracking-widest text-muted-foreground/60 mb-1">
                                                {item.label}
                                            </p>
                                            <p className="text-base font-medium text-foreground leading-relaxed whitespace-pre-line">
                                                {item.value}
                                            </p>
                                        </div>
                                    </motion.a>
                                ))}
                            </div>

                            {/* Divider */}
                            <div className="border-t border-border/40" />

                            {/* Social Links */}
                            <motion.div
                                initial={{ opacity: 0, y: 10 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ delay: 0.5 }}
                                className="space-y-4"
                            >
                                <p className="text-sm font-semibold uppercase tracking-widest text-muted-foreground/60">
                                    Connect with us
                                </p>
                                <div className="flex flex-wrap gap-4">
                                    {socials.map((s) => (
                                        <a
                                            key={s.label}
                                            href={s.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            aria-label={s.label}
                                            className={`flex items-center gap-2.5 px-5 py-3 rounded-2xl font-semibold text-sm transition-all duration-200 ${s.colorClass}`}
                                        >
                                            {s.icon}
                                            {s.label}
                                        </a>
                                    ))}
                                </div>
                            </motion.div>
                        </motion.div>
                    </div>
                </section>
            </main>

            <footer className="border-t py-12 bg-muted/30">
                <div className="container mx-auto px-6 md:px-8 text-center text-muted-foreground text-sm">
                    <p>&copy; {new Date().getFullYear()} DSAT School. All rights reserved.</p>
                </div>
            </footer>
        </div>
    )
}
